/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from "react-i18next";
import { Auth } from "aws-amplify";
import { GetUserOrganisation } from "./getUserOrganisation";
import { validatePhoneNumber } from "../validators/phoneValidator";

const validateEmail = (email: string) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const AmplifyServices = {
    Services() {
        const { t } = useTranslation("locale");

        return {
            async validateCustomSignUp(formData: {
                username: string;
                "custom:full_name": string;
                "custom:acknowledgement": string;
                phone_number: string;
                "custom:mobile_number": string;
            }): Promise<any> {
                if (
                    formData.username != undefined &&
                    validateEmail(formData.username) == null
                ) {
                    return {
                        username: "Invalid email address"
                    };
                }

                if (formData["custom:mobile_number"]) {
                    const error = validatePhoneNumber(
                        formData["custom:mobile_number"]
                    );
                    if (error) {
                        return {
                            "custom:mobile_number": error
                        };
                    }
                }

                if (
                    formData["custom:full_name"] != undefined &&
                    formData["custom:full_name"].length < 3
                ) {
                    return {
                        "custom:full_name": t("auth.name_too_short_warning")
                    };
                }

                if (formData["custom:full_name"].length >= 128) {
                    return {
                        "custom:full_name": t("auth.name_too_long_warning")
                    };
                }
            },
            async handleSignUp(formData: any) {
                const { username, password, attributes } = formData;
                const organisationInput = attributes["custom:organisation"];
                const name = attributes["custom:full_name"];
                attributes.name = name;
                const organisation = GetUserOrganisation(
                    username,
                    organisationInput
                );
                attributes["custom:organisation"] = organisation;

                return Auth.signUp({
                    username: username.trim(),
                    password,
                    attributes
                });
            },
            async handleSignIn(formData: any) {
                const { username, password } = formData;

                const signedIn = Auth.signIn({
                    username: username.trim(),
                    password
                });

                return signedIn;
            }
        };
    }
};

export const getCurrentSessionIdToken = async (): Promise<string> => {
    let token = "";

    const session = await Auth.currentSession();

    if (session) {
        token = session.getIdToken().getJwtToken();
    }

    return token;
}
